export const CLEAR_ALBUM_SIGN_OUT = 'clear_album_sign_out/CLEAR_ALBUM_SIGN_OUT';
